import {makeTrackEvent} from './makeTrackEvent';

type SandboxBillingBannerEvent = {
  action: 'Banner displayed' | 'Banner dismissed' | 'Primary CTA clicked';
  bannerState: string;
  organizationId: string;
  plan: string;
  threshold?: number;
};

export const trackSandboxBillingBanner = makeTrackEvent<
  SandboxBillingBannerEvent,
  {
    action: {
      description: 'The interaction with the local Sandbox billing banner';
      exampleValues: [
        'Banner displayed',
        'Banner dismissed',
        'Primary CTA clicked',
      ];
    };
    bannerState: {
      description: 'The resolved billing state represented by the banner';
      exampleValues: ['paygo-nudge', 'credits-low', 'cap-reached'];
    };
    organizationId: {
      description: 'The organization for which the banner was shown';
      exampleValues: ['T3JnYW5pemF0aW9uOjEyMw=='];
    };
    plan: {
      description: 'The organization plan when the banner was shown';
      exampleValues: ['Free', 'Pro', 'Enterprise'];
    };
    threshold: {
      description: 'The usage threshold that caused the banner, when applicable';
      exampleValues: [90, 100];
    };
    _description: 'Tracks impressions and actions for local Sandbox billing banners';
    _location: 'At the top of pages inside the Sandbox shell';
    _motivation: 'Measure whether plan-aware billing messages lead users to the intended next action';
  }
>('Sandbox billing banner');
